export const isExperimentOpen = (experiments = {}, experimentName) => experiments[experimentName] === true ||
    experiments[experimentName] === 'true' ||
    experiments[experimentName] === 'new';
//# sourceMappingURL=experiments.js.map